import React from 'react';
import { TextInput, Toolbar, SaveButton, ReferenceField, TextField, DateInput, ReferenceInput, DeleteButton, Link, Button, Edit, Create, SimpleForm, SelectInput } from 'react-admin';
import { parse } from "query-string";
import moment from "moment";
const EditTourDetailTitle = () => (
  <span>
    Edit Tour Detail
  </span>
);

const TourDetailEditToolbar = props => (
  <Toolbar {...props} >
      <SaveButton />
      <DeleteButton basePath={props.basePath} record={props.record} resource={props.resource} redirect={`/tours/${props.record.tour_id}/1`} /> 
  </Toolbar>
);

const CreateTourDetailTitle = () => (
  <span>
    Create Tour Detail
  </span>
);

const CancelButton = (object) => (
  <Button
      component={Link}
      to={{
          pathname: `/tours/${object.record.tour_id}/1`
      }}
      label="Cancel">
  </Button>
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const TourDetailEdit = props => {
  const tour_id =  parse(props.location.search).tour_id
  const redirect = tour_id ? `/tours/${tour_id}/1` : 'edit';

  return (
  <Edit title={<EditTourDetailTitle />} {...props}>
    <SimpleForm redirect={redirect} toolbar={<TourDetailEditToolbar />}>
        {/* <TextInput source="version" label="Version"/> */}
        <DateInput source="date"  locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} label="Day"/>
        <TextInput source="day" label="Day"/>
        <ReferenceInput label="Hotel" source="hotel_id" reference="hotels">
            <SelectInput source="id" optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Lunch" source="restaurant_id_1" reference="restaurants" sort={{ field: 'name', order: 'ASC' }}>
            <SelectInput source="id" optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Dinner" source="restaurant_id_2" reference="restaurants" sort={{ field: 'name', order: 'ASC' }}>
            <SelectInput source="id" optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Origin" source="city_origin" reference="cities" sort={{ field: 'city', order: 'ASC' }}>
            <SelectInput source="id" optionText="city"/>
        </ReferenceInput>
        <ReferenceField source="city_origin" reference="cities"  label="Country Origin" >
          <ReferenceField source="country_id" reference="countries" linkType={false}>
            <TextField source="country"/>
          </ReferenceField>
        </ReferenceField>
        <ReferenceInput label="Destination" source="city_destination" reference="cities"  sort={{ field: 'city', order: 'ASC' }}>
            <SelectInput source="id" optionText="city"/>
        </ReferenceInput>
        <ReferenceField source="city_destination" reference="cities"  label="Country Destination" >
          <ReferenceField source="country_id" reference="countries" linkType={false}>
            <TextField source="country"/>
          </ReferenceField>
        </ReferenceField>
        <CancelButton/>
    </SimpleForm>
  </Edit>
  );
}

export const TourDetailCreate = props => {
  const tour_id =  parse(props.location.search).tour_id
  const redirect = tour_id ? `/tours/${tour_id}/1` : 'edit';

  return (
  <Create title={<CreateTourDetailTitle />} {...props}>
    <SimpleForm redirect={redirect}>
        {/* <TextInput source="version" label="Version"/> */}
        <DateInput source="date"  locales="es-Es" options={{ timeZone: 'UTC' }} label="Day"/>
        <TextInput source="day" label="Day"/>
        <ReferenceInput label="Hotel" source="hotel_id" reference="hotels" sort={{ field: 'name', order: 'ASC' }}>
            <SelectInput source="id" optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Lunch" source="restaurant_id_1" reference="restaurants" sort={{ field: 'name', order: 'ASC' }}>
            <SelectInput source="id" optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Dinner" source="restaurant_id_2" reference="restaurants" sort={{ field: 'name', order: 'ASC' }}>
            <SelectInput source="id" optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Origin" source="city_origin" reference="cities" sort={{ field: 'city', order: 'ASC' }}>
            <SelectInput source="id" optionText="city"/>
        </ReferenceInput>
        <ReferenceInput label="Destination" source="city_destination" reference="cities"  sort={{ field: 'city', order: 'ASC' }}>
            <SelectInput source="id" optionText="city"/>
        </ReferenceInput>
        <CancelButton/>
    </SimpleForm>
  </Create>
  );
}


// WEBPACK FOOTER //
// ./src/resources/tourDetails.js